import { userKey } from "../App";
import useFetchData from "./useFetchData";

export const useSocial = () => {
    let stringValue = localStorage.getItem(userKey);
    let value = JSON.parse(stringValue);

    const requestOptions = {
        method: 'GET',  // Adjust the HTTP method as needed
        cacheFor: 24 * 60 * 60 * 1000, // ✅ 24 hours cache
    };

    if (value?.value) {
        requestOptions.headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Token ${value?.value}`
        };
    }

    const state = useFetchData("/domain-wise/admin-social-list/", requestOptions);
    // console.log(state?.data?.data);

    return {
        socials: state?.data?.data
    }
};

